(function () {
  'use strict';

  var SIZE_MAP = [
    { min: 43.0, max: 44.0, size: 'G', us: '3.5', eu: '46' },
    { min: 44.0, max: 44.8, size: 'G½', us: '3.75', eu: '47' },
    { min: 44.8, max: 45.5, size: 'H', us: '4.0', eu: '47' },
    { min: 45.5, max: 46.2, size: 'H½', us: '4.25', eu: '48' },
    { min: 46.2, max: 46.8, size: 'I', us: '4.5', eu: '48' },
    { min: 46.8, max: 47.4, size: 'I½', us: '4.75', eu: '49' },
    { min: 47.4, max: 48.0, size: 'J', us: '5.0', eu: '49' },
    { min: 48.0, max: 48.7, size: 'J½', us: '5.25', eu: '50' },
    { min: 48.7, max: 49.3, size: 'K', us: '5.5', eu: '51' },
    { min: 49.3, max: 49.9, size: 'K½', us: '5.75', eu: '51' },
    { min: 49.9, max: 50.6, size: 'L', us: '6.0', eu: '52' },
    { min: 50.6, max: 51.2, size: 'L½', us: '6.25', eu: '52' },
    { min: 51.2, max: 51.9, size: 'M', us: '6.5', eu: '53' },
    { min: 51.9, max: 52.5, size: 'M½', us: '6.75', eu: '54' },
    { min: 52.5, max: 53.2, size: 'N', us: '7.0', eu: '55' },
    { min: 53.2, max: 53.8, size: 'N½', us: '7.25', eu: '56' },
    { min: 53.8, max: 54.4, size: 'O', us: '7.5', eu: '56' },
    { min: 54.4, max: 55.1, size: 'O½', us: '7.75', eu: '57' },
    { min: 55.1, max: 55.7, size: 'P', us: '8.0', eu: '57' },
    { min: 55.7, max: 56.3, size: 'P½', us: '8.25', eu: '58' },
    { min: 56.3, max: 57.0, size: 'Q', us: '8.5', eu: '59' },
    { min: 57.0, max: 57.6, size: 'Q½', us: '8.75', eu: '59' },
    { min: 57.6, max: 58.3, size: 'R', us: '9.0', eu: '60' },
    { min: 58.3, max: 58.9, size: 'R½', us: '9.25', eu: '60' },
    { min: 58.9, max: 59.5, size: 'S', us: '9.5', eu: '61' },
    { min: 59.5, max: 60.2, size: 'S½', us: '9.75', eu: '62' },
    { min: 60.2, max: 60.8, size: 'T', us: '10.0', eu: '62' },
    { min: 60.8, max: 61.4, size: 'T½', us: '10.25', eu: '63' },
    { min: 61.4, max: 62.1, size: 'U', us: '10.5', eu: '63' },
    { min: 62.1, max: 62.7, size: 'U½', us: '10.75', eu: '64' },
    { min: 62.7, max: 63.4, size: 'V', us: '11.0', eu: '65' },
    { min: 63.4, max: 64.0, size: 'V½', us: '11.25', eu: '65' },
    { min: 64.0, max: 64.6, size: 'W', us: '11.5', eu: '66' },
    { min: 64.6, max: 65.3, size: 'W½', us: '11.75', eu: '67' },
    { min: 65.3, max: 65.9, size: 'X', us: '12.0', eu: '67' },
    { min: 65.9, max: 66.5, size: 'X½', us: '12.25', eu: '68' },
    { min: 66.5, max: 67.2, size: 'Y', us: '12.5', eu: '68' },
    { min: 67.2, max: 67.8, size: 'Y½', us: '12.75', eu: '69' },
    { min: 67.8, max: 69.0, size: 'Z', us: '13.0', eu: '70' },
  ];

  function initCalculator(root) {
    if (!root || root.dataset.ringCalculatorReady === 'true') return;

    var input = root.querySelector('[data-ring-calc-input]');
    var phMm =
      (input && input.getAttribute('data-ring-calc-ph-mm')) ||
      (input && input.getAttribute('placeholder')) ||
      'e.g. 52';
    var phIn =
      (input && input.getAttribute('data-ring-calc-ph-in')) || 'e.g. 2.05';
    var btnMm = root.querySelector('[data-ring-calc-unit="mm"]');
    var btnIn = root.querySelector('[data-ring-calc-unit="in"]');
    var submit = root.querySelector('[data-ring-calc-submit]');
    var letterEl = root.querySelector('[data-ring-calc-result-letter]');
    var detailEl = root.querySelector('[data-ring-calc-result-detail]');

    if (!input || !letterEl || !detailEl) return;

    var currentUnit = 'mm';

    function setUnit(u) {
      currentUnit = u;
      if (btnMm) btnMm.classList.toggle('is-active', u === 'mm');
      if (btnIn) btnIn.classList.toggle('is-active', u === 'in');
      input.placeholder = u === 'mm' ? phMm : phIn;
    }

    function calcSize() {
      var val = parseFloat(input.value);
      if (isNaN(val) || val <= 0) {
        letterEl.textContent = '?';
        detailEl.textContent = 'Please enter a valid measurement.';
        return;
      }
      var mm = currentUnit === 'in' ? val * 25.4 : val;
      var match = SIZE_MAP.find(function (s) {
        return mm >= s.min && mm < s.max;
      });

      if (match) {
        letterEl.textContent = match.size;
        detailEl.textContent =
          'US ' + match.us + ' · EU ' + match.eu + ' · ' + mm.toFixed(1) + 'mm circumference';
      } else if (mm < 43) {
        letterEl.textContent = '< G';
        detailEl.textContent = 'Outside standard range — please visit us in store.';
      } else {
        letterEl.textContent = '> Z';
        detailEl.textContent = 'Outside standard range — please visit us in store.';
      }
    }

    if (btnMm) btnMm.addEventListener('click', function () { setUnit('mm'); });
    if (btnIn) btnIn.addEventListener('click', function () { setUnit('in'); });
    if (submit) submit.addEventListener('click', calcSize);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') calcSize();
    });

    setUnit('mm');
    root.dataset.ringCalculatorReady = 'true';
  }

  function boot() {
    document.querySelectorAll('[data-ring-calculator]').forEach(initCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
